const customSelectors = {
  cartIcons: document.querySelectorAll('[data-header-cart]'),
};

var globalInfluenceData = []
class customJS {
  constructor() {
      this.openElement = customSelectors.cartIcons
      this.closeDrawer = customSelectors.cartClose
      this.bindEvents();
      this.offerCoutndownTimer();
      window.addEventListener("click", (event)=> {
        this.overLay(event);
      });
      this.megaMenuScroll();

  }
  drawerScroll(){
    console.log('it is called')
    let cart_drawer = document.querySelector('.cart-drawer');
    let bodyContent = document.querySelector("body");
    console.log(bodyContent,cart_drawer,'=======')
    if(cart_drawer.classList.contains('opened-drawer')){
      console.log('inside if')
      bodyContent.classList.add('overflow-hidden');
    }
    else{
      htmlContent.classList.remove('overflow-hidden');
    }
  }
  megaMenuScroll(){
    let influencer_menu = document.querySelector('.influencers-menu');
    let htmlContent = document.querySelector("html");
    influencer_menu.addEventListener("mouseover",()=>{
      if(influencer_menu.classList.contains('open')){
        htmlContent.classList.add('overflow-hidden');
      }
    })
    influencer_menu.addEventListener("mouseleave",()=>{
      htmlContent.classList.remove('overflow-hidden');
    })

  }
  overLay(event){
    let rebuyCart = document.querySelector('.rebuy-cart');
    if(rebuyCart != null && rebuyCart !=undefined ){
    if(rebuyCart.classList.contains('is-visible')){
    }
    else{
      let siteOverlay = document.querySelector('#site-overlay');
      siteOverlay.classList.remove('overlay--body');
    }
  }
  }
  bindEvents(){
      if(window.globalVariables.template != 'cart'){
          this.openElement.forEach(cartBtn => cartBtn.addEventListener('click', this.loadScript.bind(this)));
      }
  }
  createScript(){
      let rebuyScript = document.createElement('script');
  rebuyScript.id = 'rebuyScript';
      rebuyScript.setAttribute("async","")
  rebuyScript.src = 'https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=bunker-branding-co.myshopify.com';
      document.head.appendChild(rebuyScript);
  }
  loadScript(event){
      let _this =this
       event.preventDefault()
       _this.createScript()
  }
  offerCoutndownTimer(){
      if (document.querySelectorAll('[data-timer]').length > 0) {
        document.querySelectorAll('[data-timer-offer-banner] [data-timer]').forEach(element => {
            // Set the date we're counting down to
            const dateSelected = element.getAttribute('data-timer');
            const countDownDate = new Date(dateSelected).getTime();
            const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
            const monthNames = ["January", "February", "March", "April", "May", "June",
              "July", "August", "September", "October", "November", "December"
            ];
            const d = new Date();
            let day = weekday[d.getDay()];
            let time = formatAMPM(new Date(dateSelected));
            let selectedDay = weekday[new Date(dateSelected).getDay()];
            let selectedMonth = monthNames[new Date(dateSelected).getMonth()];
            let selectedDate = new Date(dateSelected).getDate();
            element.closest('[data-timer-offer-banner]').querySelector('[data-convert_display_date]').innerHTML = `${selectedDay},  ${selectedMonth} ${selectedDate}, ${time.replace(' ','')} CST`;
            // Update the count down every 1 second
            const x = setInterval(function() {
              // Get today's date and time
              const now = new Date().getTime();
              // Find the distance between now and the count down date
              const distance = countDownDate - now;
              // Time calculations for days, hours, minutes and seconds
              const days = Math.floor(distance / (1000 * 60 * 60 * 24));
              const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              const seconds = Math.floor((distance % (1000 * 60)) / 1000);
              // Display the result in the element with
              element.querySelector('[data-day]').innerHTML = days;
              element.querySelector('[data-hours]').innerHTML = hours;
              element.querySelector('[data-mins]').innerHTML = minutes;
              element.querySelector('[data-secs]').innerHTML = seconds;
              // If the count down is finished, write some text
              var link_text=element.closest('[data-timer-offer-banner]').getAttribute('data-timer-offer-banner');
              if (distance < 0) {
                clearInterval(x);
                if (document.querySelector(`[data-timer-offer-banner="${link_text}"]`) != null) {
                  document.querySelector(`[data-timer-offer-banner="${link_text}"]`).classList.add('d-none');
                }
                if (document.querySelector(`[data-release_banner="${link_text}"]`) != null) {
                  document.querySelector(`[data-release_banner="${link_text}"]`).classList.remove('d-none');
                }
                if (document.querySelector(`[data-release_product_slider="${link_text}"]`) != null) {
                  document.querySelector(`[data-release_product_slider="${link_text}"]`).classList.remove('d-none');
                }
                if (document.querySelector(`[data-release_product_slider="${link_text}"] .featured-collection-slider`) != null) {
                  let sliderElement = document.querySelector(`[data-release_product_slider="${link_text}"] .featured-collection-slider`);
                  let sliderOptions =  sliderElement.getAttribute('data-slider');
                  sliderOptions = JSON.parse(sliderOptions);
                  let slider = new Swiper(sliderElement, sliderOptions);
                  slider.update();
                }
              }else{
                if (document.querySelector(`[data-timer-offer-banner="${link_text}"]`) != null) {
                  document.querySelector(`[data-timer-offer-banner="${link_text}"]`).classList.remove('d-none');
                }
                if (document.querySelector(`[data-release_banner="${link_text}"]`) != null) {
                  document.querySelector(`[data-release_banner="${link_text}"]`).classList.add('d-none');
                }
                if (document.querySelector(`[data-release_product_slider="${link_text}"]`) != null) {
                  document.querySelector(`[data-release_product_slider="${link_text}"]`).classList.add('d-none');
                }
              }
            }, 1000);
        });
      }
      function formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
      }
  }
}
typeof customJS !== 'undefined' && new customJS();